import api from '@/api'
import moment from 'moment'

const state = {
  holidays: {},
  ready: false,
}

const mutations = {
  SET_HOLIDAYS (state, holidays) {
    state.holidays = {}
    holidays.forEach(x => {
      state.holidays[moment(x.date).format('YYYY-MM-DD')] = x
    })
    state.ready = true
  },
}

const actions = {
  getHolidays ({commit}) {
    if (this.ready) {
      return
    }
    api.holidays.all((holidays) => {
      commit('SET_HOLIDAYS', holidays)
    })
  },
}

const getters = {
  holidays: state => state.holidays,
  isReady: state => state.ready,
}

export default {
  state,
  actions,
  getters,
  mutations,
  namespaced: true,
}



// WEBPACK FOOTER //
// ./src/store/modules/holiday.js